import { render, staticRenderFns } from "./FacturaForm.vue?vue&type=template&id=44da23de&scoped=true"
import script from "./FacturaForm.vue?vue&type=script&lang=js"
export * from "./FacturaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da23de",
  null
  
)

export default component.exports